import OrderManagementService from '@/views/Order/OrderManagementService';
import productServices from '@/services/products';
import clientServices from '@/services/client';
import promotionServices from '@/services/promotion';
import moment from 'moment';

import { DISPLAY_DATE_FORMAT, DATE_FORMAT, MILLION } from '@/consts';

import {
  SET_ORDER,
  SET_ASSET,
  SET_CLIENT,
  SET_CONTRACT,
  SET_PRODUCT,
  SET_PROMOTION,
  RESET,
} from './types';


export default {
  async getOrderFromId({ commit }, id) {
    const orderData = await OrderManagementService.getOrderById(id);

    const order = {
      id: orderData.id,
      requiredAmount: orderData.requiredAmount / MILLION,
      proposedAmount: orderData.proposedAmount / MILLION,
      assetType: orderData.assetType,
      source: orderData.source,
      client: orderData.client,
      firstName: orderData.firstName ? orderData.firstName : '',
      phone: orderData.phone,
    };

    commit(SET_ORDER, order);
    commit(SET_ASSET, orderData.asset);

    if (orderData.client !== null) {
      const clientData = await clientServices.getClientDetail(orderData.client);

      const client = {
        id: clientData.id,
        new: false,
        firstName: clientData.firstName,
        lastName: clientData.lastName,
        dateOfBirth: moment(clientData.dateOfBirth, DATE_FORMAT).format(DISPLAY_DATE_FORMAT),
        nationalId: clientData.nationalId,
        mifosId: clientData.mifosId,
        address: clientData.address,
        district: clientData.district,
        city: clientData.city,
        gender: clientData.gender,
        primaryPhone: clientData.primaryPhone,
      };

      if (clientData.primaryPhone !== orderData.phone) {
        client.alternativePhone = orderData.phone;
      } else if (clientData.alternativePhone) {
        client.alternativePhone = clientData.alternativePhone;
      } else {
        client.alternativePhone = '';
      }

      commit(SET_CLIENT, client);
      commit(SET_CONTRACT, { validator: orderData.validator });
    } else {
      const client = {
        new: true,
        lastName: orderData.firstName ? orderData.firstName : '',
        primaryPhone: orderData.phone,
      };

      commit(SET_CLIENT, client);
    }

    if (orderData.promotion) {
      const promotionData = await promotionServices.getPromotionDetail(orderData.promotion);

      const promotion = {
        id: promotionData.id,
        promotionName: promotionData.promotionName,
        description: promotionData.description,
        interestDiscount: promotionData.interestDiscount,
        maxDiscount: promotionData.maxDiscount / MILLION,
        minDiscount: promotionData.minDiscount / MILLION,
        minPayout: promotionData.minPayout / MILLION,
      };

      commit(SET_PROMOTION, promotion);
    }
  },

  async getClientByNationalId({ commit, state }, nationalId) {
    try {
      const clientData = await clientServices.getClientByNationalId(nationalId);

      const client = {
        id: clientData.id,
        new: false,
        firstName: clientData.firstName,
        lastName: clientData.lastName,
        dateOfBirth: moment(clientData.dateOfBirth, DATE_FORMAT).format(DISPLAY_DATE_FORMAT),
        nationalId: clientData.nationalId,
        mifosId: clientData.mifosId,
        address: clientData.address,
        district: clientData.district,
        city: clientData.city,
        gender: clientData.gender,
        primaryPhone: clientData.primaryPhone,
      };

      if (clientData.primaryPhone !== state.order.phone) {
        client.alternativePhone = state.order.phone;
      } else if (clientData.alternativePhone) {
        client.alternativePhone = clientData.alternativePhone;
      } else {
        client.alternativePhone = '';
      }

      commit(SET_CLIENT, client);
    } catch(e) {
      const client = {
        new: true,
        id: null,
        primaryPhone: state.order.phone,
        alternativePhone: '',
        lastName: state.order.firstName,
        mifosId: 'XXXX',
        nationalId,
      };

      if (!state.client.new) {
        client.firstName = '';
        client.dateOfBirth = '';
        client.address = '';
        client.district = '';
        client.city = '';
        client.gender = '';
      }

      commit(SET_CLIENT, client);
    }
  },

  async getProducts({ commit }) {
    const [productResult] = await Promise.all([productServices.getProducts()]);

    const products = productResult.item.reduce((result, product) => {
      const value = { ...result };
      value[product.productDesc] = {
        id: product.id,
        productName: product.productName,
        repayEvery: product.repayEvery,
        interestValue: product.interestValue,
        prepaid: product.prepaid,
      };
      return value;
    }, {});

    commit(SET_PRODUCT, products);
  },

  async setClient({ commit }, client) {
    commit(SET_CLIENT, client);
  },
  async setOrder({ commit }, order) {
    commit(SET_ORDER, order);
  },
  async setAsset({ commit }, asset) {
    commit(SET_ASSET, asset);
  },
  async setContract({ commit }, contract) {
    commit(SET_CONTRACT, contract);
  },
  async reset({ commit }) {
    commit(RESET);
  },
};
